<template>
  <div>
    <app-button 
    class="relative mt-2 z-50" 
    :style="makeStyles(discountBtnBackgroundColor, discountBtnTextColor)"
    :onClick="toggleList"
    :title="lang['discount_code'][language]" 
    :iconName=" this.showList ? 'chevron-down' : 'chevron-up'" />

    <transition name="fade">
        <discounts-list
        :style="discountListBackgroundColor" 
        v-show="showList" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lang from "../../lang";

import AppButton from '../Button/AppButton.vue'
import DiscountsList from './DiscountsList.vue'

export default {
  props: [],
  components: { DiscountsList, AppButton },
  data() {
    return {
      showList: false,
      lang: lang
    }
  },
  computed: {
    ...mapGetters(["language"]),
    ...mapGetters("Theme", [
      "discountBtnBackgroundColor",
      "discountListBackgroundColor",
      "discountBtnTextColor",
    ]),
    ...mapGetters("Cart", [
      "automaticDiscount"
    ]),
  },
  methods: {
    toggleList() {
      this.showList = !this.showList
    }
  },
  mounted() {
    if (this.automaticDiscount != false) {
      this.showList = true
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>